import React from 'react';

import { RelatedLinks as RelatedLinksType } from '__generated__/graphql-sanity';

const checkTitles = (childCategories, siblingCategories, customLinks) => {
  const childCategoriesTitle =
    childCategories?.categories?.length === 0 ||
    childCategories?.title?.length > 0;

  const siblingCategoriesTitle =
    siblingCategories?.categories?.length === 0 ||
    siblingCategories?.title?.length > 0;

  const customLinksTitle =
    !customLinks ||
    customLinks?.every(
      link => link?.title?.length > 0 || link?.links?.length === 0
    );

  return childCategoriesTitle && siblingCategoriesTitle && customLinksTitle;
};

const renderCategoriesColumn = (
  categories,
  title,
  showTitles,
  activeRelatedLinks
) => {
  if (
    typeof activeRelatedLinks === 'object' &&
    !categories.some(category =>
      activeRelatedLinks?.some(link => link._key === category._id)
    )
  ) {
    return null;
  }

  if (
    !categories ||
    categories.length === 0 ||
    !categories.some(
      category =>
        (category?.url || category?.category?.url) &&
        (category?.name || category?.category?.name || category?.title)
    )
  ) {
    return null;
  }

  return (
    <div className="pr-2 w-full max-w-[268px]">
      {showTitles && <h2 className="font-bold mb-4 uppercase">{title}</h2>}
      <ul className="gap-3 grid">
        {categories.map(
          (category, index) =>
            (category?.url || category?.category?.url) &&
            (!activeRelatedLinks ||
              activeRelatedLinks?.some(link => link._key === category._id)) &&
            (category?.name || category?.category?.name || category?.title) && (
              <li key={index}>
                <a
                  href={category?.url || category?.category?.url}
                  className="underline uppercase"
                >
                  {category?.name ||
                    category?.category?.name ||
                    category?.title}
                </a>
              </li>
            )
        )}
      </ul>
    </div>
  );
};
export const RelatedLinks: React.FC<{
  relatedLinks: RelatedLinksType;
}> = props => {
  const {
    relatedLinks: {
      childCategories,
      siblingCategories,
      customLinks,
      activeRelatedLinks,
    },
  } = props;

  if (!childCategories && !siblingCategories && !customLinks) {
    return null;
  }

  const showTitles = checkTitles(
    childCategories,
    siblingCategories,
    customLinks
  );

  return (
    <div className="related-links grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 mt-8 text-sm gap-x-4 gap-y-8">
      {renderCategoriesColumn(
        childCategories?.categories,
        childCategories?.title,
        showTitles,
        activeRelatedLinks
      )}
      {renderCategoriesColumn(
        siblingCategories?.categories,
        siblingCategories?.title,
        showTitles,
        activeRelatedLinks
      )}
      {customLinks?.map(customCategories =>
        renderCategoriesColumn(
          customCategories?.links,
          customCategories?.title,
          showTitles,
          false
        )
      )}
    </div>
  );
};
